const state = {
  lista: [],
  textoPesquisa: '',
  status: null,
  uf: '',
  registroSelecionadoId: null,
  recarregarLista: true
}

const getters = {
  LISTA: state => state.lista,
  TEXTO_PESQUISA: state => state.textoPesquisa,
  STATUS: state => state.status,
  UF: state => state.uf,
  REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
  RECARREGAR_LISTA: state => state.recarregarLista
}

const mutations = {
  SET_LISTA(state, payload) {
    state.lista = payload
  },
  SET_TEXTO_PESQUISA(state, payload) {
    state.textoPesquisa = payload
  },
  SET_STATUS(state, payload) {
    state.status = payload
  },
  SET_UF(state, payload) {
    state.uf = payload
  },
  SET_REGISTRO_SELECIONADO_ID(state, payload) {
    state.registroSelecionadoId = payload
  },
  SET_RECARREGAR_LISTA(state, payload) {
    state.recarregarLista = payload
  },
  SET_LIMPAR(state) {
    state.textoPesquisa = ''
    state.status = null
    state.uf = ''
  }
}

const actions = {
  async GET_LISTA({ commit, state }, http) {
    try {
      const payload = {
        textoPesquisa: state.textoPesquisa,
        status: state.status,
        uf: state.uf
      }
      
      const response = await http.post('/api/protected/transportadora/pesquisar', payload)
      let dados = response.data
      if (dados && dados.data) dados = dados.data
      
      commit('SET_LISTA', dados)
      return dados
    } catch (err) {
      console.error('Erro ao buscar transportadoras:', err)
      throw err
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/transportadora-store.js